import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import MainContent from 'components/BlackNovember/MainContent';
import { COLOR_WHITE } from 'styles/variables/colors';

export default function BlackNovemberPage() {
  return (
    <BaseLayout
      hasPadding={false}
      bgBrandColor={COLOR_WHITE}
      headerWhite={true}
      typeBtn="buttonSecondary"
    >
      <Head>
        <title>Black November - Mind The Graph</title>

        <meta
          key="og:title"
          name="og:title"
          property="og:title"
          content="Black November - Mind The Graph"
        />

        <meta
          key="description"
          name="description"
          content="Explore amazing deals at Mind the Graph's Black November. Scientific graphics and unbeatable discounts to elevate your research."
        />

        <meta
          key="og:description"
          name="og:description"
          property="og:description"
          content="Explore amazing deals at Mind the Graph's Black November. Scientific graphics and unbeatable discounts to elevate your research."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
